import { render, staticRenderFns } from "./openPriceDetail.vue?vue&type=template&id=09b7c53d&"
import script from "./openPriceDetail.vue?vue&type=script&lang=js&"
export * from "./openPriceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b7c53d')) {
      api.createRecord('09b7c53d', component.options)
    } else {
      api.reload('09b7c53d', component.options)
    }
    module.hot.accept("./openPriceDetail.vue?vue&type=template&id=09b7c53d&", function () {
      api.rerender('09b7c53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/OpenPriceBatch/components/openPriceDetail.vue"
export default component.exports